module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erco-group-options"
  }, [(_vm.label) ? _c('label', {
    staticClass: "label text-muted"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.label) + "\n\t")]) : _vm._e(), _vm._v(" "), _c('b-button-group', {
    staticClass: "option-group"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('b-button', {
      key: index,
      staticClass: "option",
      attrs: {
        "size": _vm.size,
        "variant": option.active ? 'primary' : ''
      },
      on: {
        "click": function($event) {
          _vm.handleOptionClick(option)
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(option.text) + "\n\t\t")])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35ac26bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoOptionsGroup.vue
// module id = 613
// module chunks = 0